import { createContext, useContext } from "react";

export const LangContext = createContext(null);
export const ScrollContext = createContext(null);

export const useLang = () => useContext(LangContext);
export const useScrollTo = () => useContext(ScrollContext);
